var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#BB6BD9",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 23C44.87 23 45.575 23.3 46.13 23.885C46.7 24.5 47 25.175 47 26V42.5C47 43.325 46.7 44 46.13 44.615C45.575 45.2 44.87 45.5 44 45.5H20C19.13 45.5 18.425 45.2 17.87 44.615C17.3 44 17 43.325 17 42.5V26C17 25.175 17.3 24.5 17.87 23.885C18.425 23.3 19.13 23 20 23H26V20C26 19.13 26.3 18.425 26.87 17.87C27.425 17.3 28.13 17 29 17H35C35.87 17 36.575 17.3 37.13 17.87C37.7 18.425 38 19.13 38 20V23H44ZM20 26V42.5H44V26H20ZM35 23V20H29V23H35Z",
    fill: "#BB6BD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.33f397b9cbb194009774c1285839a711.svg";
export { ForwardRef as ReactComponent };